module.exports = __webpack_public_path__ + "img/缀白裘.5e225aa2.png";